<template>
    <v-card
        :color="$vuetify.theme.dark ? 'transparent' : '#E0EAF2'"
        elevation="0"
        class="all-trade-tab rounded-0"
    >
        <v-tabs
            :background-color="$vuetify.theme.dark ? 'transparent' : '#E0EAF2'"
            v-model="model"
        >
            <v-tab class="ml-0" :href="`#tab-1`"> Change MT5 Password </v-tab>
            <v-tab :href="`#tab-2`"> Change Leverage </v-tab>
            <v-tab :href="`#tab-3`"> Change Account Type </v-tab>
            
            <v-tabs-items v-model="model">
                <v-tab-item :value="`tab-1`">
                   <ChangeMT5PasswordTab></ChangeMT5PasswordTab>
                </v-tab-item>
                <v-tab-item :value="`tab-2`">
                    <ChangeLeverageTab></ChangeLeverageTab>
                </v-tab-item>
                <v-tab-item :value="`tab-3`">
                    <ChangeAccountTypeTab></ChangeAccountTypeTab>
                </v-tab-item>
                
            </v-tabs-items>
        </v-tabs>
    </v-card>
</template>

<script>
import ChangeAccountTypeTab from './ChangeAccountTypeTab.vue';
import ChangeLeverageTab from './ChangeLeverageTab.vue';
import ChangeMT5PasswordTab from './ChangeMT5PasswordTab.vue';



export default {
    components: {
        ChangeMT5PasswordTab,
        ChangeLeverageTab,
        ChangeAccountTypeTab
    },

    data() {
        return {
            model: "tab-1",
        };
    },
    
};
</script>
